import ApplicationController from "./application_controller"

export default class extends ApplicationController {
    static targets = [];

    connect() {
        super.connect();
        this.form = this.element.closest('form');
    }

    disconnect() {
        super.disconnect();
    }

    orderBy({params: {sortAs, sortDir, sortField}}) {
        this.log("orderBy", [sortField, sortAs, sortDir]);
        this.form.__orderby.value = sortField;
        this.form.__orderas.value = sortAs;
        this.form.__orderdir.value = sortDir;
        this.form.submit();
    }

    rowClick( event ) {


        if ( event.params.url ) {
            this.log('rowClick url', [event.params.url]);

            if (event.target && event.target.nodeName == 'INPUT') {
                event.stopPropagation();
            } else {
                window.location = event.params.url;
            }
        } else if ( event.params.event ) {
            this.log('rowClick event', [event.params.event,event.params.values,event.params.target]);

            let target = this.element;
            if( event.params.target == 'window.opener' )
                target = window.opener;
            else if( event.params.target == 'window' )
                target = window;

            this.dispatch(event.params.event,{
                detail: event.params.values,
                target: target, prefix: false
            });
        }
    }

    submit({params: {action, actionValue}}) {
        this.log("submit", [action]);
        this.form.__action.value = action;
        this.form.__actionvalue.value = actionValue;
        this.form.submit();
    }
}
